import React from 'react'
import { Contactpage } from '../components/Contactpage'
import { Footer } from '../components/Footer'

export function Contact() {
    return (
        <div>
            <Contactpage />
            <Footer />
        </div>
    )
}

